import { ComponentInstance } from "@uniformdev/canvas";

import { SideNav } from "@/libraries/design/components/side-nav/src/side-nav";
import { SideNavProps } from "@/libraries/design/components/side-nav/src/side-nav";

export interface UniformSideNavProps {
    component: ComponentInstance;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const transformNavItemData = (slots: any) => {
    return slots.map((childComponent: ComponentInstance) => {
        const childProps = childComponent.parameters ?? {};
        if (childComponent.type === "sideNavLink") {
            return {
                type: "link",
                text: childProps["text"]?.value as string,
                href: childProps["href"]?.value as string
            };
        }
        if (childComponent.type === "sideNavCollection") {
            return {
                type: "collection",
                collectionName: childProps["collectionName"]?.value as string,
                sideNavItems: transformNavItemData(
                    childComponent.slots?.["sideNavItems"]
                )
            };
        }
        return;
    });
};

const UniformSideNav = ({ component }: UniformSideNavProps) => {
    const slotItems = component.slots?.["sideNavItems"] ?? null;
    if (!slotItems) return;

    const sideNavItems = transformNavItemData(slotItems);
    const props: SideNavProps = {
        title: component.parameters?.["title"]?.value as string,
        sideNavItems: sideNavItems
    };

    return <SideNav {...props} />;
};

export default UniformSideNav;
